import { BadgeEuro, Banknote, Smartphone, Box } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function JobPaymentControls({ job, onChange }) {
  const paid = job.payment_status === "paid";
  const method = job.payment_method || null;
  const cashbox = !!job.cashbox;

  const togglePaid = async () => {
    const prev = job.payment_status;
    onChange({ payment_status: paid ? "pending" : "paid" });
    try {
      await api.post(`/jobs/${job.id}/payment`);
    } catch (e) {
      onChange({ payment_status: prev });
      toast.error("No se pudo actualizar el pago");
    }
  };

  const setMethod = async (m) => {
    const prev = method;
    const prevCashbox = cashbox;
    const next = method === m ? "none" : m;
    // Switching away from efectivo clears the Cajita.
    onChange({ payment_method: next === "none" ? null : next, cashbox: next === "efectivo" ? cashbox : false });
    try {
      await api.post(`/jobs/${job.id}/method`, null, { params: { method: next } });
    } catch (e) {
      onChange({ payment_method: prev, cashbox: prevCashbox });
      toast.error("No se pudo actualizar el método");
    }
  };

  const toggleCashbox = async () => {
    if (method !== "efectivo") {
      toast.error("La Cajita solo se puede activar con Efectivo");
      return;
    }
    const prev = cashbox;
    onChange({ cashbox: !cashbox });
    try {
      await api.post(`/jobs/${job.id}/cashbox`);
    } catch (e) {
      onChange({ cashbox: prev });
      toast.error("No se pudo actualizar la Cajita");
    }
  };

  const base = "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs font-semibold transition-colors";
  const cashboxDisabled = method !== "efectivo";

  return (
    <div className="flex items-center gap-1.5 flex-wrap justify-end">
      <button onClick={togglePaid} data-testid={`payment-toggle-${job.id}`}
        className={`${base} ${paid ? "bg-green-100 text-green-700 hover:bg-green-200" : "bg-orange-100 text-orange-700 hover:bg-orange-200"}`}>
        <BadgeEuro className="h-3.5 w-3.5" />
        {paid ? "Pagado" : "Pendiente"}
      </button>
      <button onClick={() => setMethod("efectivo")} data-testid={`method-efectivo-${job.id}`}
        className={`${base} ${method === "efectivo" ? "bg-emerald-100 text-emerald-700 hover:bg-emerald-200" : "bg-muted text-muted-foreground hover:bg-accent"}`}>
        <Banknote className="h-3.5 w-3.5" />
        Efectivo
      </button>
      <button onClick={() => setMethod("bizum")} data-testid={`method-bizum-${job.id}`}
        className={`${base} ${method === "bizum" ? "bg-sky-100 text-sky-700 hover:bg-sky-200" : "bg-muted text-muted-foreground hover:bg-accent"}`}>
        <Smartphone className="h-3.5 w-3.5" />
        Bizum
      </button>
      <button onClick={toggleCashbox} disabled={cashboxDisabled} data-testid={`method-cajita-${job.id}`}
        title={cashboxDisabled ? "Solo disponible con Efectivo" : "Guardado en la cajita"}
        className={`${base} ${cashbox ? "bg-amber-100 text-amber-700 hover:bg-amber-200" : "bg-muted text-muted-foreground hover:bg-accent"} ${cashboxDisabled ? "opacity-40 cursor-not-allowed" : ""}`}>
        <Box className="h-3.5 w-3.5" />
        Cajita
      </button>
    </div>
  );
}
